"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { getCurrentUser } from "@/lib/auth";

type GroupEditCtaProps = {
    entityType: string;
    entityId: string;
};

export default function GroupEditCta({ entityType, entityId }: GroupEditCtaProps) {
    const [href, setHref] = useState<string | null>(null);

    useEffect(() => {
        async function load() {
            const profile = await getCurrentUser();
            if (!profile) return;

            const normalizedRole = (profile.role || "").toLowerCase();
            const assignments = profile.assignments || [];
            const hasLeadershipAssignment = assignments.some((a: any) => {
                if (String(a.entity_id) !== String(entityId)) return false;
                if ((a.entity_type || "").toLowerCase() !== entityType) return false;
                const role = (a.role || "").toLowerCase();
                return role.includes("chair") || role.includes("leader");
            });

            if (hasLeadershipAssignment || ["admin", "superadmin", "staff"].includes(normalizedRole)) {
                setHref(`/dashboard/manage/groups/${entityType}/${entityId}/edit`);
            }
        }
        load();
    }, [entityType, entityId]);

    if (!href) return null;

    return (
        <div style={{ marginBottom: "1.5rem" }}>
            <Link href={href}>
                <button
                    style={{
                        background: "#007a8a",
                        color: "white",
                        border: "none",
                        padding: "0.75rem 1.5rem",
                        borderRadius: "0.75rem",
                        fontWeight: 700,
                        cursor: "pointer",
                        fontSize: "1rem",
                    }}
                >
                    Edit Group Details
                </button>
            </Link>
        </div>
    );
}
